<template lang='pug'>
  button.social-button.component(
    unselectable='on'
    :type='type'
    :title='title'
  )
    slot
</template>

<script>
  export default {
    name: 'social-button.component',

    props: {
      type: { type: String, default: 'button' },
      title: String
    }
  }
</script>

<style scoped lang='stylus'>
  .social-button
    height 28px
    width 28px
    border-radius 50%
    text-align center
    color var(--clr-light)
    transition all 320ms
    font-size 1.25em
    &:hover, &:focus
      color white
      box-shadow var(--shadow-box)
    &:active
      transform scale(.8)
    &.facebook
      background rgb(60 90 153)
    &.twitter
      background rgb(29 161 242)
    &.google
      background rgb(221 75 57)
    &.email
      background rgb(250 175 50)
    &.messenger
      background rgb(100 100 100)

</style>
